export default __webpack_public_path__ + "static/media/outline-icons.c3146b35.ttf";